<nav class="navbar navbar-expand navbar-light bg-secondary sticky-top">
  <div
    [ngClass]="isLoginPage ? 'container' : 'container-fluid'"
    class="nav-container"
  >
    <span class="navbar-brand">
      <img src="assets/FXCH.v2.1.png" alt="fxch-logo" height="100%" />
    </span>

    <div
      class="collapse navbar-collapse"
      id="navbarCollapse"
      [collapse]="isCollapsed"
      [isAnimated]="true"
      *ngIf="!isLoginPage"
    >
      <ul class="navbar-nav me-auto mb-2 mb-md-0" *ngIf="isHeaderMenuVisible">
        <li class="nav-item">
          <a
            class="nav-link"
            (click)="activateRoute('statements')"
            [class.active]="activeNavigation === 'statements'"
            [routerLink]="'statements'"
            >Statements</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            (click)="activateRoute('report')"
            [class.active]="activeNavigation === 'report'"
            [routerLink]="'report'"
            >Reports</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            (click)="activateRoute('account-information')"
            [class.active]="activeNavigation === 'account-information'"
            [routerLink]="'account-information'"
            >Account information</a
          >
        </li>
      </ul>
      <div class="navbar-nav me-auto mb-2 mb-md-0" *ngIf="!isReportPage"></div>
      <div class="d-flex">
        <ul class="navbar-nav mx-auto me-md-auto mb-2 mb-md-0">
          <li class="nav-item">
            <button class="btn btn-sm btn-link disabled">
              Version:
              <span>
                {{ appVersion }}
              </span>
            </button>
          </li>
          <li
            class="nav-item"
            *ngIf="role === Role.ADMINISTRATOR || role === Role.GROUP"
          >
            <button class="btn btn-sm btn-link disabled">
              Account ID:
              <span *ngIf="!isAccountSelectionPage">
                {{ selectedAccount || 'Not selected' }}
              </span>
              <span *ngIf="isAccountSelectionPage"> Not selected </span>
            </button>
          </li>
          <li
            class="nav-item pe-md-2"
            *ngIf="role === Role.ADMINISTRATOR || role === Role.GROUP"
          >
            <button
              class="btn btn-sm btn-outline-primary"
              [disabled]="isAccountSelectionPage"
              (click)="activateRoute('account-selection')"
              [class.active]="activeNavigation === 'account-selection'"
              [routerLink]="'account-selection'"
            >
              Switch <i class="fa fa-exchange"></i>
            </button>
          </li>
          <li class="nav-item pt-2 pt-md-0">
            <button
              id="logoutButton"
              class="btn btn-sm btn-outline-primary"
              (click)="logout()"
            >
              Logout <i class="fa fa-sign-out"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div class="collapse navbar-collapse" *ngIf="isLoginPage">
      <ul class="navbar-nav ms-auto mb-2 mb-md-0">
        <li class="nav-item">
          <button class="btn btn-sm btn-link disabled">
            Contact Information
          </button>
        </li>
      </ul>
    </div>
  </div>
</nav>
